import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const ScrollToAnchor = () => {
    const location = useLocation();
    const lastHash = useRef('');

    const { initLoading, loading } = useSelector(state => state.auth)
    useEffect(() => {
        if (location.hash) {
            lastHash.current = location.hash.slice(1);
        }
        if (lastHash.current && document.getElementById(lastHash.current) && !initLoading && !loading) {
            setTimeout(() => {
                document
                    .getElementById(lastHash.current)
                    ?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                lastHash.current = '';
            }, 100);
        }
    }, [location, initLoading, loading])
}

export default ScrollToAnchor